import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "qk-topbar"
}
const _hoisted_2 = { class: "qk-topbar__left" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "menu-block" }
const _hoisted_5 = { class: "menu-block__main" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "qk-topbar__right"
}

import { computed, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { apiGetRmsEnvCountry } from '@/api/envCountry';
import { apiGetUserInfo } from '@/api/user';
import shared from '@/shared';
import actions from '@/shared/actions';
import { useLangStore } from '@/store/langStore';
import getExtraUrl from '@/utils/extraUrl';
import { isSubPath, normalizeMenus } from '@/utils/helper';
import { doSsoLogout, getLoginUrl } from '@/utils/login';
import { setSentryUser } from '@/utils/sentry';

import Setting from '../setting/Setting.vue';
import SwitchLanguage from '../switchLanguage/Index.vue';
import SwitchRegion from '../switchRegion/Index.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'top',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const langStore = useLangStore(); // 添加这一行

const roleName = ref('');
const userInfo = ref<Project.IUserInfo>({
  account: '',
  email: '',
  userName: ''
});
const originMenus = ref<Project.ISubProject[]>([]);
const showTopbar = ref(false);

// 检查是否应该激活 global-channel-retail 菜单项
const shouldActivateChannelRetail = computed(() => {
  return (
    route.path.includes('main-global-position-patrol') &&
    typeof window !== 'undefined' &&
    window.location.href.includes('main-global-position-patrol')
  );
});

// 使用全局前置守卫
router.beforeEach((to, from, next) => {
  showTopbar.value = !to.meta.hideTopbar;
  next();
});

const handleMenuClick = (item: Project.ISubProject) => {
  langStore.setProject(item.projectTag);
  // 跳转到目标项目
  window.location.href = `/main-${item.projectTag}`;
};

watch(
  () => route.path,
  (newPath) => {
    showTopbar.value = !route.meta.hideTopbar;
  }
);

onMounted(() => {
  getUserInfo();
  getRmsEnvCountry();
  langStore.initProject();
  console.log('store', langStore.$state);

  actions.onGlobalStateChange((state) => {
    // 子应用可能会把roleName传给主应用
    roleName.value = state.roleName;
    originMenus.value = normalizeMenus(state.projects);
  }, true);
  actions.offGlobalStateChange();
});

async function getRmsEnvCountry() {
  try {
    const rmsEnvCountryRes = await apiGetRmsEnvCountry();
    console.log('getRmsEnvCountry result:', rmsEnvCountryRes);
    localStorage.setItem('rmsEnvCountry', JSON.stringify(rmsEnvCountryRes.data));
  } catch (error) {
    console.log('getRmsEnvCountry error:', error);
  }
}

// 获取用户信息  项目列表
async function getUserInfo() {
  try {
    const { data } = await apiGetUserInfo();
    userInfo.value = data;

    // 用户信息存入setGlobalState供子项目使用
    actions.setGlobalState({ userInfo: data });
    localStorage.setItem('userInfo', JSON.stringify(data));

    // 设置 Sentry 用户信息，用于追踪 Crash Free Users
    setSentryUser(data);
  } catch (error) {
    // console.error(error);

    setTimeout(() => {
      if (route.path !== '/login') {
        window.location.href = getLoginUrl();
      }
    }, 1000);
  }
}

async function logout() {
  const beforeLogout = shared.getBeforeLogout();

  if (!beforeLogout) {
    doSsoLogout();
    return;
  }
  try {
    const res = await beforeLogout();
    if (res?.canLogout) {
      doSsoLogout();
    }
  } catch (e) {
    console.log('logout err', e);
  }
}

return (_ctx: any,_cache: any) => {
  return (showTopbar.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "logo" }, null, -1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('global.appName')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(originMenus.value, (item) => {
              return _withDirectives((_openBlock(), _createElementBlock("li", {
                key: item.name,
                class: _normalizeClass(["menu-item", {
            'is-active':
              _unref(isSubPath)(item.path || '', _unref(route).path) ||
              (shouldActivateChannelRetail.value && item.projectTag === 'global-channel-retail')
          }])
              }, [
                _createElementVNode("a", {
                  class: "menu-item-title",
                  onClick: _withModifiers(($event: any) => (handleMenuClick(item)), ["prevent"])
                }, _toDisplayString(item.projectName), 9, _hoisted_6)
              ], 2)), [
                [_vShow, item.projectTag !== 'global-position-patrol']
              ])
            }), 128))
          ])
        ]),
        (userInfo.value.account)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(SwitchRegion),
              _createVNode(SwitchLanguage),
              _createVNode(Setting, {
                "user-info": userInfo.value,
                "role-name": roleName.value,
                onLogout: logout
              }, null, 8, ["user-info", "role-name"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})